<template>
  <div>
    <v-row v-if="!isRequestEndorsement">
      <v-col cols="12">
        <p class="form__title primary--text mb-5">
          DADOS FINANCEIROS
        </p>
      </v-col>
    </v-row>
    <v-row v-if="isPolicyWithoutQuotation" class="pb-6">
      <v-col cols="12" sm="6" class="pr-sm-5">
        <BaseMoney
          id-element="valueFinancialData"
          placeholder="Inserir Valor"
          v-model="form.valor_importancia_segurada"
          required
          :rules="[requiredInput]"
          label-text="Importância Segurada Emissão"
          :disabled="disableForm"
        />
      </v-col>
      <v-col cols="12" class="pt-7" v-if="!isSubmodalityJudicialRecursal">
        <BaseFormTextArea
          id-element="descriptionResourceQuotation"
          placeholder="Descreva"
          v-model="form.composicao_importancia_segurada"
          required
          :rules="[requiredInput, maxLengthTextArea]"
          label-text="Composição da Importância Segurada"
          text-information="Aqui você deve descrever o que compõe o valor da importância segurada, exemplo: valor de contrato, agravos previstos em processos, etc..."
          icon-information
        />
      </v-col>
    </v-row>
    <v-row v-if="isEndorsement && !isRequestEndorsement">
      <v-col cols="12" class="pb-5">
        <v-switch
          v-model="form.sem_movimento_premio"
          class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
          inset
          dense
          hide-details
          color="secondary"
          :disabled="disableForm"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          Sem movimento de prêmio?
        </p>
      </v-col>
      <v-col cols="12" class="pb-5" v-if="enableForm">
        <v-radio-group v-model="form.fator_premio.id" row>
          <v-radio
            v-for="(item, key) in itemsTypePayment"
            :key="key"
            :label="item.nome"
            :value="item.id"
            :disabled="disableForm"
          />
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row v-if="enableForm">
      <fragment v-if="form.fator_premio.id == 'pagamento'">
        <v-col cols="12" sm="6" md="4" class="pr-sm-5">
          <BaseMoney
            id-element="bonusFinancialData"
            placeholder="R$ 1.000,00"
            v-model="form.valor_premio"
            required
            :rules="[requiredInput]"
            label-text="Prêmio (R$)"
            :disabled="disableForm"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pr-md-5">
          <BaseFormSelect
            id-element="paymentFinancialData"
            placeholder="Selecionar"
            v-model="form.forma_pagamento"
            required
            :rules="[requiredInput]"
            label-text="Forma de Pagamento"
            :items="listPaymentMethods"
            item-text="nome"
            item-value="id"
            :return-object="true"
            :disabled="disableForm"
          />
        </v-col>
        <v-col cols="12" sm="5" md="4" class="pr-sm-5 pr-md-0">
          <BaseFormInput
            id-element="deadlineFinancialData"
            :placeholder="deadlineFinancialDataPlaceholder"
            v-model="form.data_vencimento"
            required
            :rules="[requiredInput, dateTermValid]"
            validate-on-blur
            v-facade="maskDate"
            label-text="Data Vencimento 1ª Parcela"
            :disabled="disableForm"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pr-sm-5">
          <BaseFormInput
            id-element="parcelFinancialData"
            :placeholder="parcelFinancialDataPlaceholder"
            v-model="form.numero_parcela"
            required
            :rules="[requiredInput, isValidParcelPolicy]"
            label-text="Parcelas"
            type="number"
            :disabled="disableForm"
          />
        </v-col>
        <v-col cols="12" sm="3" class="pt-sm-8 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CALCULAR'"
            @click="generateTable"
            class="secondary"
            width="100%"
            :disabled="disableForm"
          />
        </v-col>
      </fragment>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5 pb-5" v-else>
        <BaseMoney
          id-element="bonusFinancialData"
          placeholder="R$ 1.000,00"
          v-model="form.valor_premio"
          required
          :rules="[requiredInput]"
          label-text="Valor a Restituir (R$)"
          :disabled="disableForm"
          icon-information
          text-information="Os prazos de crédito em conta do valor a restituir são definidos pela seguradora."
        />
      </v-col>
    </v-row>
    <v-row v-if="enableForm">
      <v-col
        cols="12"
        class="pb-12"
        v-if="hasTable && form.fator_premio.id == 'pagamento'"
      >
        <v-row>
          <v-col cols="12" md="6" xl="5">
            <v-row class="pb-2">
              <v-col cols="4" md="3" class="pr-2">
                <div class="table-financial-data__header">
                  N° Parcela
                </div>
              </v-col>
              <v-col cols="4" class="pr-2">
                <div class="table-financial-data__header">
                  Vencimento
                </div>
              </v-col>
              <v-col cols="4">
                <div class="table-financial-data__header">
                  Valor
                </div>
              </v-col>
            </v-row>
            <v-row v-for="(item, key) in tableList" :key="key" class="pb-2">
              <v-col cols="4" md="3" class="pr-2">
                <div class="table-financial-data__number gray--text caption">
                  {{ item.numero }}
                </div>
              </v-col>
              <v-col cols="4" class="pr-2">
                <v-text-field
                  class="table-financial-data__value gray--text caption px-0"
                  v-model="item.vencimento"
                  outlined
                  dense
                  v-facade="maskDate"
                  :disabled="disableForm"
                />
              </v-col>
              <v-col cols="4">
                <money
                  v-model="item.valor"
                  v-bind="money"
                  class="table-financial-data__value gray--text caption"
                  :disabled="disableForm"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <BaseMoney
          id-element="percentageFinancialData"
          placeholder="Inserir"
          v-model="form.percentual_comissao"
          required
          :rules="[requiredInput]"
          label-text="Percentual Comissão"
          :disabled="disableForm"
          :money="typePercentage"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-md-5">
        <BaseMoney
          id-element="taxBonusFinancialData"
          placeholder="Inserir"
          v-model="form.taxa_premio"
          required
          :rules="[requiredInput]"
          label-text="Taxa Prêmio"
          :disabled="disableForm"
          :money="typePercentage"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-8" v-if="!isRequestEndorsement">
        <v-divider />
      </v-col>
      <v-col cols="12">
        <p class="form__title primary--text mb-5">
          DOCUMENTOS
        </p>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="pb-5 pb-sm-0 pr-sm-5"
        v-if="!isRequestEndorsement"
      >
        <p class="body-2 font-weight-bold primary--text mb-2">
          {{ nameDocument }}
        </p>
        <DropFile
          @selected-files="addFilesPolicy"
          :multiple="false"
          class="mb-5"
          v-if="withoutPolicy"
          :disabled="disableForm"
        />
        <DocumentDataTable
          v-if="hasPolicy"
          :documents="form.apolice"
          @preview-file="onPreviewFile"
          @remove-file="onRemoveFilePolicy"
          :disabled="disableForm"
        />
        <BaseErrorMessages
          v-if="errorMessages.length > 0"
          :error-messages="errorMessages"
        />
      </v-col>
      <v-col cols="12" sm="6" v-if="!isRequestEndorsement">
        <p class="body-2 font-weight-bold primary--text mb-2">
          Anexar Boleto
        </p>
        <DropFile
          @selected-files="addFilesBills"
          :multiple="true"
          class="mb-5"
          :disabled="disableForm"
        />
        <DocumentDataTable
          v-if="hasBills"
          :documents="form.boletos"
          @preview-file="onPreviewFile"
          @remove-file="onRemoveFileBills"
          :disabled="disableForm"
        />
        <BaseErrorMessages
          v-if="errorMessagesBills.length > 0"
          :error-messages="errorMessagesBills"
        />
      </v-col>
      <v-row v-if="isEndorsement">
        <v-col cols="12" v-if="!isModalityJudicial">
          <p class="body-2 font-weight-bold primary--text mb-2">
            Anexar arquivos auxiliares
          </p>
          <p class="form__label primary--text mb-2">
            São recomendados anexar os seguintes arquivos:
          </p>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          class="pb-5 pb-sm-0 pr-sm-5"
          v-if="!isModalityJudicial"
        >
          <div class="policy-form-section__type-files pa-4">
            <p class="primary--text">
              * Inserir documentos que comprovem a motivação do pedido de
              cancelamento.
            </p>
          </div>
        </v-col>
        <v-col cols="12" sm="6" :class="classWithModalityJudicialToFiles">
          <p
            class="body-2 font-weight-bold primary--text mb-2"
            v-if="isModalityJudicial"
          >
            Anexar arquivos auxiliares
          </p>
          <DropFile
            @selected-files="addOthersFiles"
            :multiple="true"
            class="mb-5"
            :disabled="disableForm"
          />
          <DocumentDataTable
            v-if="hasOthersFiles"
            :documents="form.anexos"
            @preview-file="onPreviewFile"
            @remove-file="onRemoveOthersFile"
            :disabled="disableForm"
          />
        </v-col>
        <v-col cols="12" sm="6" :class="classWithModalityJudicialToObservation">
          <BaseFormTextArea
            id-element="reasonCancelEndorsement"
            placeholder="Inserir"
            v-model="form.observacoes"
            :rules="[maxLengthTextArea]"
            label-text="Observações"
            :disabled="disableForm"
          />
        </v-col>
      </v-row>
    </v-row>
  </div>
</template>
<script>
import {
  requiredInput,
  isValidParcelPolicy,
  dateTermValid,
  maxLengthTextArea,
  greaterThanZero
} from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import { FILE } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import DocumentDataTable from "@/components/DocumentDataTable";
import DropFile from "@/components/DropFile";
import _ from "lodash";
import { mapState } from "vuex";
import {
  formatIsoDateToDDMMYYYY,
  addMonthsToDDMMYYYY
} from "@/utils/formats.js";
const TYPE_RESTITUTION = { nome: "Restituição", id: "restituicao" };
const TYPE_PAYMENT = { nome: "Pagamento", id: "pagamento" };
export default {
  data: () => ({
    componentKey: 0,
    requiredInput,
    isValidParcelPolicy,
    dateTermValid,
    greaterThanZero,
    maskDate,
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      suffix: "",
      precision: 2,
      masked: false /* doesn't work with directive */
    },
    header: [
      { text: "N° Parcelas", value: "parcela", sortable: false },
      { text: "Vencimento", value: "vencimento", sortable: false },
      { text: "Valor", value: "valor", sortable: false }
    ],
    formatIsoDateToDDMMYYYY,
    addMonthsToDDMMYYYY,
    maxLengthTextArea,
    itemsTypePayment: [TYPE_PAYMENT, TYPE_RESTITUTION]
  }),
  components: {
    DocumentDataTable,
    DropFile
  },
  mixins: [DocumentsMixin],
  created() {
    // AVISO: Essa mesma regra teve que ser replicada em RequestEndorsementMixin.js, ver comentário
    // lá no fim do método updateEditForm() se for alterar isso aqui.
    this.form.fator_premio =
      this.form.fator_premio || _.cloneDeep(TYPE_PAYMENT);
  },
  computed: {
    ...mapState("insuranceCompany", ["listPaymentMethods"]),
    hasPolicy() {
      return this.form.apolice && this.form.apolice.length > 0;
    },
    enableForm() {
      return (
        (this.isEndorsement &&
          !this.form.sem_movimento_premio &&
          !this.isRequestEndorsement) ||
        !this.isEndorsement
      );
    },
    deadlineFinancialDataPlaceholder() {
      if (!this.form.data_vencimento) {
        return "DD/MM/AAAA";
      }

      return this.form.data_vencimento;
    },
    parcelFinancialDataPlaceholder() {
      if (!this.form.numero_parcela) {
        return "Inserir";
      }

      return this.form.numero_parcela.toString();
    },
    withoutPolicy() {
      return this.form.apolice && this.form.apolice.length == 0;
    },
    hasBills() {
      return this.form.boletos && this.form.boletos.length > 0;
    },
    hasTable() {
      return this.form.parcelas && this.form.parcelas.length > 0;
    },
    tableList() {
      return this.form.parcelas;
    },
    hasOthersFiles() {
      return this.form.anexos && this.form.anexos.length > 0;
    },
    ruleValidDateParcel() {
      return this.form.forma_pagamento?.id == "boleto"
        ? [this.requiredInput, this.dateTermValid]
        : [];
    },
    ruleValidNumberParcels() {
      return this.form.forma_pagamento?.id == "boleto"
        ? [this.requiredInput, this.isValidParcelPolicy]
        : [];
    },
    isSubmodalityJudicialRecursal() {
      return this.form.submodalidade?.id === "judicial_recursal";
    },
    isModalityJudicial() {
      return this.currentPolicy.modalidade?.id == "judicial";
    },
    classWithModalityJudicialToFiles() {
      return this.isModalityJudicial
        ? "pb-5 pb-sm-0 pr-sm-5 pt-5"
        : "pb-5 pb-sm-0";
    },
    classWithModalityJudicialToObservation() {
      return this.isModalityJudicial ? "pt-4" : "pr-sm-5";
    },
    typePercentage() {
      return {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: " %",
        precision: 2,
        masked: false /* doesn't work with directive */
      };
    }
  },
  methods: {
    generateTable() {
      var actualIndividualValue =
        Math.floor((this.form.valor_premio / this.form.numero_parcela) * 100) /
        100;

      var remainingValue = this.form.valor_premio;

      var parcels = [];

      for (var i = 0; i < this.form.numero_parcela; ++i) {
        var parcelValue;
        if (i == this.form.numero_parcela - 1) {
          parcelValue = remainingValue;
        } else {
          parcelValue = actualIndividualValue;
          remainingValue -= actualIndividualValue;
        }

        parcels[i] = {
          numero: i + 1,
          vencimento: this.formatIsoDateToDDMMYYYY(
            this.addMonthsToDDMMYYYY(this.form.data_vencimento, i)
          ),
          valor: parcelValue
        };
      }

      this.form.parcelas = parcels;
    },
    updatePolicy(item) {
      this.form.apolice = item;
    },
    updateBills(item) {
      this.form.boletos = item;
    },
    addFilesBills(files) {
      this.form.boletos = this.form.boletos.concat(
        files.map(file => ({
          arquivo: {
            [FILE]: file,
            nome: file.name
          }
        }))
      );
    },
    onRemoveFileBills(item) {
      this.form.boletos = this.form.boletos.filter(document =>
        document.arquivo
          ? document.arquivo.nome !== item.arquivo.nome
          : document.nome !== item.nome
      );
    },
    addFilesPolicy(files) {
      this.form.apolice = this.form.apolice.concat(
        files.map(file => ({
          arquivo: {
            [FILE]: file,
            nome: file.name
          }
        }))
      );
      this.form.apolice = [this.form.apolice[0]];
    },
    onRemoveFilePolicy(item) {
      this.form.apolice = this.form.apolice.filter(document =>
        document.arquivo
          ? document.arquivo.nome !== item.arquivo.nome
          : document.nome !== item.nome
      );
    },
    addOthersFiles(files) {
      this.form.anexos = this.form.anexos.concat(
        files.map(file => ({
          arquivo: {
            [FILE]: file,
            nome: file.name
          }
        }))
      );
    },
    onRemoveOthersFile(item) {
      this.form.anexos = this.form.anexos.filter(document =>
        document.arquivo
          ? document.arquivo.nome !== item.arquivo.nome
          : document.nome !== item.nome
      );
    }
  },
  watch: {
    "form.fator_premio"(value) {
      if (!value) this.form.fator_premio = _.cloneDeep(TYPE_PAYMENT);
    }
  },
  props: {
    form: {
      type: Object
    },
    isPolicyWithoutQuotation: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: function() {
        return [];
      }
    },
    errorMessagesBills: {
      type: Array,
      default: function() {
        return [];
      }
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    nameDocument: {
      type: String,
      default: "Anexar Apólice"
    },
    isRequestEndorsement: {
      type: Boolean,
      default: false
    },
    disableForm: {
      type: Boolean,
      default: false
    },
    currentPolicy: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.table-financial-data__
  &header
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #F0F0F7
    height: 50px
    padding: 17.5px 15px
    color: #232633
    font-size: 14px
    font-weight: 600
    width: 100% !important
  &value
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #FFFFFF
    height: 40px
    padding: 12px 15px
    width: 100% !important
    fieldset
      border: 0 !important
  &number
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #F0F0F7
    height: 40px
    padding: 12px 15px
    width: 100% !important
.policy-form-section__
  &type-files
    border: 1px solid #D5D5E0 !important
    border-radius: 2px !important
    background-color: #FFFFFF !important
</style>
